// capture nos.:  12   23 4               43   1 5   5 6  6
var pattern = /^((.+?)(@(window|document))?->)?(.+?)#(.+)$/;

var ActionDescriptor =
/** @class */
function () {
  function ActionDescriptor(identifier, eventName, methodName, eventTarget) {
    this.identifier = identifier;
    this.eventName = eventName;
    this.methodName = methodName;
    this.eventTarget = eventTarget;
  }

  ActionDescriptor.forOptions = function (options) {
    return new ActionDescriptor(options.identifier || error("Missing identifier in action descriptor"), options.eventName || error("Missing event name in action descriptor"), options.methodName || error("Missing method name in action descriptor"), options.eventTarget || error("Missing event target in action descriptor"));
  };

  ActionDescriptor.forElementWithInlineDescriptorString = function (element, descriptorString) {
    try {
      var options = this.parseOptionsFromInlineActionDescriptorString(descriptorString);
      options.eventName = options.eventName || this.getDefaultEventNameForElement(element);
      options.eventTarget = options.eventTarget || element;
      return ActionDescriptor.forOptions(options);
    } catch (error) {
      throw new Error("Bad action descriptor \"" + descriptorString + "\": " + error.message);
    }
  };

  ActionDescriptor.parseOptionsFromInlineActionDescriptorString = function (descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match(pattern) || error("Invalid action descriptor syntax");
    return {
      identifier: matches[5],
      eventName: matches[2],
      methodName: matches[6],
      eventTarget: parseEventTarget(matches[4])
    };
  };

  ActionDescriptor.getDefaultEventNameForElement = function (element) {
    return this.defaultEventNames[element.tagName.toLowerCase()](element);
  };

  Object.defineProperty(ActionDescriptor.prototype, "eventTargetName", {
    get: function get() {
      return stringifyEventTarget(this.eventTarget);
    },
    enumerable: true,
    configurable: true
  });

  ActionDescriptor.prototype.isEqualTo = function (descriptor) {
    return descriptor != null && descriptor.identifier == this.identifier && descriptor.eventName == this.eventName && descriptor.methodName == this.methodName && descriptor.eventTarget == this.eventTarget;
  };

  ActionDescriptor.prototype.toString = function () {
    var eventNameSuffix = this.eventTargetName ? "@" + this.eventTargetName : "";
    return "" + this.eventName + eventNameSuffix + "->" + this.identifier + "#" + this.methodName;
  };

  ActionDescriptor.defaultEventNames = {
    "a": function a(e) {
      return "click";
    },
    "button": function button(e) {
      return "click";
    },
    "form": function form(e) {
      return "submit";
    },
    "input": function input(e) {
      return e.getAttribute("type") == "submit" ? "click" : "change";
    },
    "select": function select(e) {
      return "change";
    },
    "textarea": function textarea(e) {
      return "change";
    }
  };
  return ActionDescriptor;
}();

export { ActionDescriptor };

function error(message) {
  throw new Error(message);
}

function parseEventTarget(eventTargetName) {
  if (eventTargetName == "window") {
    return window;
  } else if (eventTargetName == "document") {
    return document;
  }
}

function stringifyEventTarget(eventTarget) {
  if (eventTarget == window) {
    return "window";
  } else if (eventTarget == document) {
    return "document";
  }
}